import useTailwindConfig from './useTailwindConfig';
import {ref, watch} from 'vue';

export default function useBreakpoints() {
    const config = useTailwindConfig();
    const breakpoints = config.theme.screens;
    const currentBreakpoints = ref([]);
    let events = [];

    const isBreakpoint = breakpoint => window.innerWidth > parseInt(breakpoints[breakpoint]);
    const isMobile = ref(!isBreakpoint('lg'));


    const triggerEvents = () => {
        events.forEach(event => event());
    };

    function whenBreakpointChanges(expression) {
        // plaats alle breakpoints in de reactieve array
        setBreakpoints();

        window.addEventListener('resize', function (e) {
            setBreakpoints();
        });
        // plaats de meegegeven functie in een array die later wordt uitgevoerd
        events.push(expression);
    }

    const setBreakpoints = () => {
        for (const [key, value] of Object.entries(breakpoints)) {
            if (isBreakpoint(key)) {
                if (!currentBreakpoints.value.includes(key)) {
                    currentBreakpoints.value.push(key);
                }
            } else {
                if (currentBreakpoints.value.includes(key)) {
                    const index = currentBreakpoints.value.indexOf(key);
                    currentBreakpoints.value.splice(index, 1);
                }
            }
        }
    };


    watch(() => currentBreakpoints.value.length, () => {
        triggerEvents();
        isMobile.value = !currentBreakpoints.value.includes('lg');
    });

    return {
        isMobile,
        currentBreakpoints,
        breakpoints,
        isBreakpoint,
        whenBreakpointChanges,
    };
}